<div class="product-wrapper row justify-content-start">
  <div class="col-12 col-md-6 mb-2">
    <div class="product-box">
      <div class="info-box">
        <div class="product-wrapper">
          <div class="row no-gutters price-label">
            <div class="col-12">
              <div class="singleFund col-12">
                <div class="w-99 product-wrapper">
                  <!-- <kendo-dropdownlist
                    [formControl]="fundId"
                    [data]="currentUser?.marginTradeDetails"
                    [valuePrimitive]="false"
                    [valueField]="'customerCode'"
                    textField="customerName"
                    tabindex="1"
                    [popupSettings]="{ height: 200, 'z-index': 1000 }"
                  >
                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                      <span class="template">{{ dataItem?.customerName }} [{{ dataItem?.customerCode }}]</span>
                      <span class="signed-acc-types">
                        <i class="far joint fa-handshake" [hidden]="dataItem.index === 0"></i>
                        <i class="ind fas fa-user-tie" [hidden]="dataItem.index !== 0"></i>
                      </span>
                    </ng-template>
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      <span class="template"> {{ dataItem?.customerName }} [{{ dataItem?.customerCode }}] </span>
                      <span class="signed-acc-types">
                        <i class="far joint fa-handshake" [hidden]="dataItem.index === 0"></i>
                        <i class="ind fas fa-user-tie" [hidden]="dataItem.index !== 0"></i>
                      </span>
                    </ng-template>
                  </kendo-dropdownlist> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 mb-2">
    <div class="product-box">
      <div class="info-box">
        <div class="product-wrapper">
          <div class="row no-gutters ledger-info">
            <div class="col-12 pt-2 pb-3">
              <b>Balance (BDT)</b>
              <span
                ><b>{{ availablebalance | number : 2 : true }}</b></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 col-md-11 mb-2 mt-2">
    <ul class="sub-nav">
      <li [routerLinkActive]="['active']" [routerLink]="'/dashboard/ledger/portfolio/' + investerCode" routerLinkActive="active">
        <span>Portfolio</span>
      </li>

      <li [routerLinkActive]="['active']" [routerLink]="'/dashboard/ledger/summary/' + investerCode" routerLinkActive="active">
        <span>Summary</span>
      </li>
    </ul>
  </div>
</div>

<div class="card-1">
  <table class="table table-bordered table-responsive-lg table-sm table-striped">
    <thead>
      <tr>
        <th>Transaction Date</th>
        <th>Details</th>
        <th>Quantity</th>
        <th>Rate</th>
        <th>Amount</th>
        <th>Balance</th>
        <th>Debit</th>
        <th>Credit</th>
        <th>Opening Bal</th>
        <th>Closing Bal</th>
        <th>Scheme Type</th>
      </tr>
    </thead>
    <tbody>
      <tr class="text-center">
        <td colspan="17">
          <div [hidden]="!summaryLoading" class="loader text-center"></div>
          <div [hidden]="summaryLoading || ledgerSummary?.length > 0">No Records Available</div>
        </td>
      </tr>
      <tr [hidden]="summaryLoading" *ngFor="let su of ledgerSummary">
        <td>{{ su.transactionDate | date : 'y-MM-dd' }}</td>
        <td>{{ su.details }}</td>
        <td class="text-end">{{ su.quantity | number : 2 : false }}</td>
        <td class="text-end">{{ su.rate | number : 2 : false }}</td>
        <td class="text-end">{{ su.amount | money }}</td>
        <td class="text-end">{{ su.balance | money }}</td>
        <td class="text-end">{{ su.debit | money }}</td>
        <td class="text-end">{{ su.credit | money }}</td>
        <td class="text-end">{{ su.openingBalance | money }}</td>
        <td class="text-end">{{ su.closingBalance | money }}</td>
        <td>{{ su.schemeType }}</td>
      </tr>
    </tbody>
  </table>
</div>
